import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.sort.js";
import { useRef as b, useState as S } from "react";
import { disposables as E } from '../utils/disposables.js';
import { once as g } from '../utils/once.js';
import { useDisposables as L } from './use-disposables.js';
import { useFlags as y } from './use-flags.js';
import { useIsoMorphicEffect as C } from './use-iso-morphic-effect.js';
var D = function (i) {
  return i[i.None = 0] = "None", i[i.Closed = 1] = "Closed", i[i.Enter = 2] = "Enter", i[i.Leave = 4] = "Leave", i;
}(D || {});
function A(e) {
  var a = {};
  for (var t in e) e[t] === !0 && (a["data-".concat(t)] = "");
  return a;
}
function V(e, a, t, r) {
  var _S = S(t),
    _S2 = _slicedToArray(_S, 2),
    i = _S2[0],
    u = _S2[1],
    _y = y(e && i ? 3 : 0),
    d = _y.hasFlag,
    f = _y.addFlag,
    s = _y.removeFlag,
    l = b(!1),
    n = b(!1),
    o = L();
  return C(function p() {
    var T;
    if (!e) return;
    t && u(!0);
    var c = a.current;
    return c ? ((T = r == null ? void 0 : r.start) == null || T.call(r, t), M(c, {
      inFlight: l,
      prepare: function prepare() {
        n.current ? n.current = !1 : n.current = l.current, l.current = !0, !n.current && (t ? (f(3), s(4)) : (f(4), s(2)));
      },
      run: function run() {
        n.current ? t ? (s(3), f(4)) : (s(4), f(3)) : t ? s(1) : f(1);
      },
      done: function done() {
        var m;
        n.current && typeof c.getAnimations == "function" && c.getAnimations().length > 0 || (l.current = !1, s(7), t || u(!1), (m = r == null ? void 0 : r.end) == null || m.call(r, t));
      }
    })) : t ? (f(3), o.nextFrame(function () {
      return p();
    })) : void 0;
  }, [e, t, a, o]), e ? [i, {
    closed: d(1),
    enter: d(2),
    leave: d(4),
    transition: d(2) || d(4)
  }] : [t, {
    closed: void 0,
    enter: void 0,
    leave: void 0,
    transition: void 0
  }];
}
function M(e, _ref) {
  var a = _ref.prepare,
    t = _ref.run,
    r = _ref.done,
    i = _ref.inFlight;
  var u = E();
  return R(e, {
    prepare: a,
    inFlight: i
  }), u.nextFrame(function () {
    u.add(F(e, r)), t();
  }), u.dispose;
}
function F(e, a) {
  var t = g(a),
    r = E();
  if (!e) return r.dispose;
  var _getComputedStyle = getComputedStyle(e),
    i = _getComputedStyle.transitionDuration,
    u = _getComputedStyle.transitionDelay,
    _map = [i, u].map(function (l) {
      var _l$split$filter$map$s = l.split(",").filter(Boolean).map(function (o) {
          return o.includes("ms") ? parseFloat(o) : parseFloat(o) * 1e3;
        }).sort(function (o, p) {
          return p - o;
        }),
        _l$split$filter$map$s2 = _slicedToArray(_l$split$filter$map$s, 1),
        _l$split$filter$map$s3 = _l$split$filter$map$s2[0],
        n = _l$split$filter$map$s3 === void 0 ? 0 : _l$split$filter$map$s3;
      return n;
    }),
    _map2 = _slicedToArray(_map, 2),
    d = _map2[0],
    f = _map2[1],
    s = d + f;
  if (s !== 0) {
    var l = r.group(function (n) {
      var o = n.setTimeout(function () {
        t(), n.dispose();
      }, s);
      n.addEventListener(e, "transitionrun", function (p) {
        p.target === p.currentTarget && (o(), n.addEventListener(e, "transitioncancel", function (c) {
          c.target === c.currentTarget && (t(), l());
        }));
      });
    });
    r.addEventListener(e, "transitionend", function (n) {
      n.target === n.currentTarget && (t(), r.dispose());
    });
  } else t();
  return r.dispose;
}
function R(e, _ref2) {
  var a = _ref2.inFlight,
    t = _ref2.prepare;
  if (a != null && a.current) {
    t();
    return;
  }
  var r = e.style.transition;
  e.style.transition = "none", t(), e.offsetHeight, e.style.transition = r;
}
export { A as transitionDataAttributes, V as useTransition };